export default "/_next/static/images/2016-3x-a5583c4dcbc17c9a661235937cb83cff.png";